export default __webpack_public_path__ + "send_inactive.a55f9f5e.svg";